import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {Router} from "@angular/router";
import {Store} from "@ngxs/store";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LogoutAction} from "../../actions/auth.actions";
import {SendToast} from "../../actions/toast.actions";
import {ToastType} from "../../actions/core.actions";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private router: Router, private store: Store, private modalService: NgbModal) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log(request)
    return next.handle(request).pipe(
      tap(r => {
        // this.store.dispatch(new ClearServerError({}));
          if (r instanceof HttpResponse) {
            if(r.status == 500) {
              this.store.dispatch([new SendToast({
                title: 'Error ',
                content: "Ocurrió un error. Reintente más tarde.",
                style: ToastType.Error,
                timeout: 8000,
                closeable: false,
                progress: false,
                timestamp: new Date().getTime()
              })]);
            }
          }
      }),
      catchError((err: HttpErrorResponse) => {
        if(err.status >= 500) {
          this.store.dispatch([new SendToast({
            title: 'Error ',
            content: "Ocurrió un error. Reintente más tarde.",
            style: ToastType.Error,
            timeout: 8000,
            closeable: false,
            progress: false,
            timestamp: new Date().getTime()
          })]);
        }
        return throwError(err);
      }));
  }

}
